

































































































import { computed, defineComponent, toRefs } from '@vue/composition-api';
import AppButton from '@berlin-front/common/components/elements/AppButton';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import AppLink from '@berlin-front/common/components/elements/AppLink';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';
import IntroduceArticle from '@berlin-front/common/components/elements/IntroduceArticle';
import { useContext } from '@berlin-front/common/composables/context';
import { AtoneMemberTypePostResponseMemberTypeEnum } from '@netprotections/berlin-bff';
import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { TEXT_COLOR, TEXT_SIZE, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import { ROUTE_NAME } from '@/router/route-name';

import payment from '@assets/img/payment.svg';
import point from '@assets/img/point.svg';
import register from '@assets/img/register.svg';

import { ThemeContext } from '@berlin-front/common/services/ThemeContext';
import transformSvg from '@utils/transformSvg';
import { AtoneAuthIntroContext } from './context';

export default defineComponent({
  name: 'AuthIntroView',
  components: {
    AppButton,
    AppCard,
    AppContainer,
    AppLink,
    AppRow,
    AppText,
    IntroduceArticle,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
  },

  setup() {
    const { useIntro } = useContext(AtoneAuthIntroContext);
    const { themeParameter } = useContext(ThemeContext);

    const svg = computed(() => {
      const mapper = {
        __PRIMARY_COLOR__: themeParameter.value?.primaryColor ?? '#0092cc',
        __PRIMARY_BG_COLOR__: themeParameter.value?.primaryBackgroundColor ?? '#f5f7fa',
      };
      return {
        payment: transformSvg(payment, mapper),
        point: transformSvg(point, mapper),
        register: transformSvg(register, mapper),
      };
    });

    const {
      memberType,
      goToAtoneauthLogin,
      goToAtoneauthRegisterNpAccount,
      goToAtoneauthRegisterAccount,
      SERVICE_DESCRIPTION_URL,
    } = toRefs(useIntro());

    return {
      memberType,
      goToAtoneauthLogin,
      goToAtoneauthRegisterNpAccount,
      goToAtoneauthRegisterAccount,
      MEMBER_TYPE: AtoneMemberTypePostResponseMemberTypeEnum,

      SERVICE_DESCRIPTION_URL,
      ROUTE_NAME,
      TEXT_WEIGHT,
      TEXT_SIZE,
      TEXT_COLOR,

      svg,
    };
  },
});
